import { contextStore } from "../auth/context-store.js";
import { PermissionCode } from "../../permissions/permissions.js";
import type { AIReviewSubjectType } from "../../domain/ai-review/ai-review-model.js";
import "./ai-review-panel.js";
import "./ai-assistant-drawer.js";

const esc = (v: unknown): string => String(v ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
const BOUND = Symbol("aiReviewHostBound");

/**
 * INSPECT IA REVIEW dentro de um relatório: o painel "INSPEÇÃO AUTOMÁTICA IA"
 * e o botão ASSISTENTE TÉCNICO. Uma função só para todas as telas — a
 * fiação não é copiada em cada módulo.
 */
export function aiReviewSlot(type: AIReviewSubjectType, reportId: string | null | undefined, heading: string): string {
  if (!reportId || !contextStore.hasPermission(PermissionCode.AiReviewRead)) return "";
  const assistant = contextStore.hasPermission(PermissionCode.AiAssistantUse);
  return `
    <div class="ai-review-slot" style="margin-top:12px;">
      ${assistant ? `<div style="display:flex; justify-content:flex-end;"><button type="button" class="btn-action sm" data-ai-open-assistant="1" data-heading="${esc(heading)}">ASSISTENTE TÉCNICO</button></div>` : ""}
      <ai-review-panel data-type="${esc(type)}" data-id="${esc(reportId)}"></ai-review-panel>
      ${assistant ? `<ai-assistant-drawer data-type="${esc(type)}" data-id="${esc(reportId)}"></ai-assistant-drawer>` : ""}
    </div>`;
}

/**
 * Liga o botão do assistente e o recarregamento do relatório quando a
 * revisão aplica texto (evento `ai-review-applied`). Idempotente: pode ser
 * chamada a cada render.
 */
export function bindAiReviewHost(host: HTMLElement, reload: () => Promise<void>): void {
  const h = host as HTMLElement & { [BOUND]?: boolean };
  if (h[BOUND]) return;
  h[BOUND] = true;
  host.addEventListener("click", e => {
    const btn = (e.target as HTMLElement).closest<HTMLElement>("[data-ai-open-assistant]");
    if (!btn) return;
    const drawer = host.querySelector("ai-assistant-drawer") as (HTMLElement & { open?: (o: { title?: string }) => void }) | null;
    drawer?.open?.({ title: btn.dataset["heading"] || "Assistente Técnico" });
  });
  host.addEventListener("ai-review-applied", () => { void reload(); });
}
